import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '../shared/services/auth';

export const authGuard: CanActivateFn = (route, state) => {
  if(inject(AuthService).isUserAuthenticated()) {
   return true;
  }
  const router = inject(Router);

  // redirect to login and preserve return URL
  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url },
  });
};
